import React, { FC } from 'react';
import { Typography } from '@design-system/typography';

import { ArticleHeadingProps } from './models';

const ArticleHeading: FC<ArticleHeadingProps> = ({ title, headingType }) => (
  <Typography tag={headingType} variant="headline" content={title} weight="bold" size="xxxl" />
);

export default ArticleHeading;
